import { Component } from '@angular/core';

@Component({
  selector: 'empty',
  templateUrl: './empty.component.html'
})
export class EmptyComponent { }

